import React from 'react';
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';

function Videos(props) {
  const { videos = [], currentVideo } = props;
  const selected = videos.findIndex(video => video.source === currentVideo);

  return (
    <AwesomeSlider fillParent infinite={false} selected={selected}>
      {videos.map(video =>
        <div className="VideoWrapper" key={video.source}>
          {/* <p className="Caption">{video.caption}</p> */}
          <video className="Video" src={video.source} controls autoPlay></video>
        </div>
      )}
    </AwesomeSlider>
  );
}

export default Videos;
